$(".footer-block__heading").click(function() {
  $(this).toggleClass('open');
  $(this).parent().find('.footer-block__details-content').slideToggle();
});

$('.image-popup-main-svg').click(function(){
  if($(this).hasClass('active')){
    $(this).removeClass('active');
  }else{
    $(this).addClass('active');    
  }
  if($(this).parent('.image-popup-main-block').find('.image-popup-text').hasClass('active')){
    $(this).parent('.image-popup-main-block').find('.image-popup-text').removeClass('active')
  }else{
    $(this).parent('.image-popup-main-block').find('.image-popup-text').addClass('active')
  }
})

$('.image-popup-mobile-show').click(function(){
  $(this).parent('.image-popup-mobile').find('.image-popup-mobile-hide').slideToggle();
})

$('.video-popup-col-2-block').click(function() {
  var id = $(this).attr('data_id');
  
  $('.video-popup-parent-div').addClass('active');
  $('body').addClass('overflow-hiddens')
  
  $('.video-popup-parent-div').find('.video-popup-main-div[data_id="' + id + '"]').addClass('active');
  var video = $('.video-popup-parent-div').find('.video-popup-main-div[data_id="' + id + '"]').find('video')[0]; 
  if (video) {
    video.play();
  }
});

$(".video-popup-close-svg").click(function(){
  $('body').removeClass('overflow-hiddens')
  var popup = $(this).parents('.video-popup-parent-div');
  
  popup.find('video').each(function() {
    var video = this;
    video.pause();
    video.currentTime = 0; 
  });

  popup.removeClass('active');
  $(this).parent('.video-popup-main-div').removeClass('active');
});


$(".blog-article-main-button").click(function(){
  var tag = $(this).data('tag');

  $(this).parents('.blog-article-block-button .blog-article-main-button').removeClass('active');
  $(this).addClass('active')

  if(tag == "all"){
    $(this).parents('.main-blog').find('.blog-articles__article').removeClass('hide');
  }else{
    $(this).parents('.main-blog').find('.blog-articles__article').addClass('hide');
    $(this).parents('.main-blog').find('.blog-articles__article[data-tag="'+tag+'"]').removeClass('hide');
  }
});


$('.cu-product-info-tab').click(function(){
  $(this).parent('.cu-product-info-image').toggleClass('active')
  $(this).parent('.cu-product-info-image').find('img').slideToggle()
})


// $(document).on("click","variant-selects input",function() {
//   setTimeout(function() {
//     fetch(`${window.location.href}`).then((response) => {
//       return response.text();
//     })
//     .then((responseText) => {
//       const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.product__info-container');
//       document.querySelector('.product-form__submit').innerHTML = html.querySelector('.product-form__submit').innerHTML;
//     })
//     .catch(e => {
//       console.error(e);
//     })
//     .finally(() => {
//     });
//   }, 1000);
// });

  // function enableAutoRemoveOnZeroQty() {
  //   document.querySelectorAll('.quantity__button[name="minus"]').forEach(function (button) {
  //     button.addEventListener('click', function () {
  //       setTimeout(function () {
  //         const input = button.parentElement.querySelector('.quantity__input');
  //         const currentQty = parseInt(input.value);
  //         const variantId = input.dataset.quantityVariantId;
  //         debugger
  //         if (currentQty === 0) {
  //           fetch('/cart/change.js', {
  //             method: 'POST',
  //             headers: {
  //               'Content-Type': 'application/json'
  //             },
  //             body: JSON.stringify({
  //               id: variantId,
  //               quantity: 0
  //             })
  //           })
  //           .then(res => res.json())
  //           .then(data => {
  //             location.reload();
  //           })
  //           .catch(error => console.error('Error removing item:', error));
  //         }
  //       }, 150);
  //     });
  //   });
  // }

  // document.addEventListener('DOMContentLoaded', enableAutoRemoveOnZeroQty);
  // document.addEventListener('shopify:section:load', enableAutoRemoveOnZeroQty);


